/*
  JJ CUSTOM · Watch-band landing page (men) · behaviour
  1. Cross-fade gallery per product section (dots, swipe, optional autoplay)
  2. Quiz bridge: makes the RevenueHunt size quiz open for the RIGHT band
     when several bands sit on one page.

  How the quiz bridge works
  - Each jj-wb-product section renders snippets/jj-quiz-product.liquid for its
    own product and stores the result in window.JJQuizProducts[productId].
  - The quiz result script (RevenueHunt custom JS) reads window.JJQuizProduct
    when the result page runs. Just before the quiz opens (click on a
    [data-jj-quiz] link) we point window.JJQuizProduct at the clicked band.
  - The quiz reads the colour from the page's variant picker or, failing that,
    from ?variant= in the URL (pageColour() in the quiz script). The landing page
    has no theme variant picker, so we write the variant that matches the chosen
    colour into the URL with history.replaceState (no reload, no navigation).
*/
(function () {
  'use strict';
  // the file is included by every product section: run it once
  if (window.__jjWbLoaded) return;
  window.__jjWbLoaded = true;

  /* ------------------------------------------------------------------ */
  /* 1. Gallery                                                          */
  /* ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Gallery(root) {
    if (root.__jjGallery) root.__jjGallery.destroy();
    root.__jjGallery = this;
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-jj-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-jj-dot]'));
    this.index = 0;
    this.lastTouch = 0;
    this.visible = true;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    this.interval = Math.max(3, parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;
    if (this.slides.length < 2) return;

    var self = this;
    this.onDot = function (e) {
      var i = parseInt(e.currentTarget.getAttribute('data-jj-dot'), 10);
      self.touched();
      self.go(i);
    };
    this.dots.forEach(function (d) { d.addEventListener('click', self.onDot); });

    // swipe (touch + pen/mouse drag)
    var startX = null, startY = null;
    this.onDown = function (e) {
      var p = e.touches ? e.touches[0] : e;
      startX = p.clientX; startY = p.clientY;
    };
    this.onUp = function (e) {
      if (startX === null) return;
      var p = e.changedTouches ? e.changedTouches[0] : e;
      var dx = p.clientX - startX, dy = p.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        self.touched();
        self.go(self.index + (dx < 0 ? 1 : -1));
      }
    };
    root.addEventListener('touchstart', this.onDown, { passive: true });
    root.addEventListener('touchend', this.onUp, { passive: true });

    // keyboard: arrows when a dot has focus
    this.onKey = function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        self.touched();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
        if (self.dots[self.index]) self.dots[self.index].focus();
        e.preventDefault();
      }
    };
    this.dots.forEach(function (d) { d.addEventListener('keydown', self.onKey); });

    // only autoplay while on screen
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        self.visible = entries[0] && entries[0].isIntersecting;
      }, { threshold: 0.25 });
      this.io.observe(root);
    }
    if (this.autoplay) {
      this.timer = setInterval(function () {
        if (!self.visible || document.hidden) return;
        if (Date.now() - self.lastTouch < 10000) return; // pause 10s after interaction
        self.go(self.index + 1);
      }, this.interval);
    }
    // enable the fade only after first paint, so the first photo does not fade in on load
    requestAnimationFrame(function () { root.classList.add('is-ready'); });
  }

  Gallery.prototype.touched = function () { this.lastTouch = Date.now(); };

  Gallery.prototype.go = function (i) {
    var n = this.slides.length;
    var next = ((i % n) + n) % n;
    if (next === this.index) return;
    var prev = this.index;
    this.slides.forEach(function (s, k) {
      s.classList.remove('is-prev');
      if (k === prev) { s.classList.remove('is-active'); s.classList.add('is-prev'); }
      if (k !== next) s.setAttribute('aria-hidden', 'true');
    });
    var target = this.slides[next];
    target.classList.remove('is-active');
    void target.offsetWidth; // restart the fade animation
    target.classList.add('is-active');
    target.removeAttribute('aria-hidden');
    this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === next ? 'true' : 'false'); });
    this.index = next;
  };

  Gallery.prototype.destroy = function () {
    clearInterval(this.timer);
    if (this.io) this.io.disconnect();
  };

  function initGalleries(scope) {
    (scope || document).querySelectorAll('[data-jj-gallery]').forEach(function (el) { new Gallery(el); });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Colour swatches: label "Kleur: Goud"                             */
  /* ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-jj-colour]')) return;
    var box = input.closest('[data-jj-colours]');
    var out = box && box.querySelector('[data-jj-colour-label]');
    if (out) out.textContent = input.value;
  });

  /* ------------------------------------------------------------------ */
  /* 3. Quiz bridge                                                      */
  /* ------------------------------------------------------------------ */
  var isColourName = function (n) { return /kleur|colou?r/i.test(String(n || '')); };

  function variantForColour(product, colour) {
    if (!product || !product.variants || !product.variants.length) return null;
    var names = product.option_names || [];
    var idx = -1;
    for (var i = 0; i < names.length; i++) { if (isColourName(names[i])) { idx = i; break; } }
    var list = product.variants;
    if (idx > -1 && colour) {
      list = product.variants.filter(function (v) { return v.options && v.options[idx] === colour; });
    }
    var available = list.filter(function (v) { return v.available; });
    return available[0] || list[0] || null;
  }

  function setVariantInUrl(id) {
    if (!id || !window.history || !history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      url.hash = '';
      history.replaceState(history.state, '', url.pathname + url.search);
    } catch (e) {}
  }

  // capture phase: runs before RevenueHunt's own listener and before the #quiz hash change
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-jj-quiz]');
    if (!link) return;
    var id = link.getAttribute('data-jj-product');
    var store = window.JJQuizProducts || {};
    var product = store[id];
    if (!product) return; // nothing to switch; quiz falls back to whatever is set
    window.JJQuizProduct = product;

    var section = link.closest('[data-jj-product-section]');
    var picked = section && section.querySelector('[data-jj-colour]:checked');
    var v = variantForColour(product, picked ? picked.value : '');
    if (v) setVariantInUrl(v.id);
  }, true);

  /* ------------------------------------------------------------------ */
  /* boot + theme editor support                                         */
  /* ------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGalleries(); });
  } else {
    initGalleries();
  }
  document.addEventListener('shopify:section:load', function (e) { initGalleries(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-jj-gallery]').forEach(function (el) { if (el.__jjGallery) el.__jjGallery.destroy(); });
  });
  // selecting an image block in the customizer shows that photo
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-jj-slide]');
    if (!slide) return;
    var g = slide.closest('[data-jj-gallery]');
    if (g && g.__jjGallery) {
      g.__jjGallery.touched();
      g.__jjGallery.go(g.__jjGallery.slides.indexOf(slide));
    }
  });
})();
